@if(isBrowser){
<main>
  <!-- header START -->
  <div class="container-fluid">
    <app-header (shareUserDetail)="setUserDetails($event)"></app-header>
  </div>
  <!-- header END -->
  <div>
    <section class="body-left-insidepages wow animate__fadeInLeft">
      <div class="body-pad">
        <article>
          <div class="tab">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs" style="max-width:676px !important;">
              <li class=" wow animate__fadeInRight"><a routerLink="terms-of-service" data-bs-toggle="tab"
                  [ngClass]="{'active': activePolicy == 'terms-of-service'}">Terms of Service</a></li>
              <li class="wow animate__fadeIn"><a routerLink="email-policy" data-bs-toggle="tab"
                  [ngClass]="{'active': activePolicy == 'email-policy'}">Email Policy</a></li>
              <li class="wow animate__fadeInLeft"><a routerLink="privacy-policy" data-bs-toggle="tab"
                  [ngClass]="{'active': activePolicy == 'privacy-policy'}">Privacy Policy</a></li>
              <li class="wow animate__fadeInLeft"><a routerLink="security" data-bs-toggle="tab"
                  [ngClass]="{'active': activePolicy == 'security'}">Security</a></li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content tabs">
              <router-outlet></router-outlet>
            </div>
          </div>
        </article>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
      <app-footer></app-footer>
    </section>
    <section class="body-right-insidepages animate__animated animate__fadeInRight"> <a routerLink="/">
        <div class="pic-area">
          <div class="pic-zoom box07"></div>
          <div class="page-head">
            <div class="cross"><img src="theme/images/cross.svg" width="25" alt="cross"></div>
            <h2>Our Policies <img src="theme/images/offers-kudoshub-icon.svg" width="40" alt="Who we are KudosHub"
                class="icon-pad"></h2>
          </div>
        </div>
      </a>
    </section>
  </div>
</main>
}